import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const propsSchema: PropsSchemaList = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXTAREA,
    options: {
      maxLength: 75,
    },
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXTAREA,
    options: {
      maxLength: 50,
    },
  },
  {
    key: 'descriptionHeader',
    label: 'Dropdown Content',
    type: types.ARRAY,
    children: [
      {
        key: 'descriptionHeaderDropdown',
        label: 'Dropdown Text:',
        type: types.TEXT,
        options: {
          maxLength: 50,
        },
      },
      {
        key: 'descriptionHeaderText',
        label: 'Description:',
        type: types.TEXTAREA,
        options: {
          maxLength: 500,
        },
      },
      {
        key: 'backgroundImage',
        label: 'Background Image',
        type: types.ARRAY,
        children: [
          {
            key: 'responsiveImgs',
            label: 'Images',
            type: types.S3_ASSET_URL,
            options: {
              cropEnabled: true,
              croppers: [
                {
                  name: 'small',
                  description: 'Small (0-899px)',
                  aspectRatio: '425 / 497',
                },
                {
                  name: 'medium',
                  description: 'Medium (900px-1199px)',
                  aspectRatio: '520 / 293',
                },
                {
                  name: 'large',
                  description: 'Large (1200px+)',
                  aspectRatio: '520 / 293',
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    key: 'carouselAutoplaySpeed',
    label: 'Autoplay Speed (in seconds)',
    type: types.TEXT,
  },
];

const defaultProps = {
  title: 'The 1st Production-Intent FF 91 Completion',
  subtitle: 'BORN IN CALIFORNIA. \nGLOBAL DNA.',
  descriptionHeader: [
    {
      descriptionHeaderDropdown: 'LOS ANGELES, CA',
      descriptionHeaderText: 'The FF 91 and FF’s world-class vehicle technology platform is designed and engineered by hundreds of talented employees at the FF headquarters in Los Angeles, California. Globally, FF has filled over 1,000 patent applications.',
      backgroundImage: {
        responsiveImgs: ''
      },
    },
  ],
  carouselAutoplaySpeed: '5',
};

export default {
  title: 'MapView Header',
  id: 'MapViewHeader',
  propsSchema,
  defaultProps
};
